import React from 'react';
import { Card } from "react-bootstrap";
import face_tamas_tettamanti from "../../assets/img/face_tamas_tettamanti.jpg";
import ShowMoreText from "react-show-more-text";
import proj_road_dynamics_modelling from "../../assets/img/proj_road_dynamics_modelling.png";

const T_Tettamanti_dynamics_modeling = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_road_dynamics_modelling} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_tamas_tettamanti}
              /* this will be the text on the banner */
              alt="System identification method for road traffic dynamics modeling"
            />{" "}
            <p className="text7">Tamás Tettamanti</p>
            <br />
            <p className="text8">
              Professor{" "}
            </p>
            <p className="text8">BME Traffic Lab</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The task is to investigate and assess/benchmark different system identification methods to 
            create reliable road traffic models, e.g., car-following (driver) model, intersection model, 
            highway model. The suggested identification methods are available in Matlab’s System 
            Identification Toolbox, but any other approach (programming language, SW) are welcome. 
            The workflow starts with the data generation of input-output pairs. To do so, you will apply 
            <a href="https://sumo.dlr.de">SUMO traffic simulation</a> on different traffic scenarios. You can use 
            “ready-to-go” <a href="https://github.com/bmetrafficlab/Sumo_intersection_catalog">models</a> or you 
            create your own custom model. After generating a number of simulation data, you can 
            explore the different identification methods, e.g., <a href="https://www.mathworks.com/help/ident/ug/black-box-modeling.html">
            black box identification tools</a> in Matlab. The main output of the 
            research is to find usable identification methods for driver model / urban traffic model / 
            freeway traffic model.

            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                <a href="https://en.wikipedia.org/wiki/System_identification">System identification</a>
                </li>
                <li>
                <a href="https://www.mathworks.com/videos/system-identification-part-1-what-is-system-identification-1636628273301.html">
                What is system identification?</a>
                </li>
                <li>
                <a href="https://www.mathworks.com/help/ident/getting-started-1.html">
                Matlab System Identification Toolbox</a>
                </li>

                
            </ul>
            

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default T_Tettamanti_dynamics_modeling;